import { render, staticRenderFns } from "./PageCatalog.vue?vue&type=template&id=ee2541a8&scoped=true&"
import script from "./PageCatalog.vue?vue&type=script&lang=js&"
export * from "./PageCatalog.vue?vue&type=script&lang=js&"
import style0 from "./PageCatalog.vue?vue&type=style&index=0&id=ee2541a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2541a8",
  null
  
)

export default component.exports